import {
    DisplaySettingSection,
    DisplayType,
} from "../core/types/system/DisplayType";

export const displaySettings: DisplayType[] = [
    {
        type: "user",
        section: DisplaySettingSection.Main,
        name: "Users",
        value: "1",
        twoName: {
            type: "userNames",
            order: false,
            format: 0,
        },
        titles: {
            type: "",
            order: true,
            format: 0,
            value: false,
        },
        example: function (builder) {
            return builder(
                "margaret.d@emails.com",
                "Margaret",
                "Margaret",
                "Danton",
                "Mrs.",
            );
        },
    },
    {
        type: "yardDutyAreas",
        name: "Yard Duty Areas",
        section: DisplaySettingSection.Main,
        value: "1",
        example: function (builder) {
            return builder("OV", "Oval");
        },
    },
    {
        type: "periods",
        name: "Periods",
        section: DisplaySettingSection.Main,
        value: "1",
        example: function (builder) {
            return builder("4", "Period 4");
        },
    },
    {
        type: "yardDutySessions",
        name: "Yard Duty Sessions",
        section: DisplaySettingSection.Main,
        value: "1",
        example: function (builder) {
            return builder("L2", "Lunch 2");
        },
    },
    {
        type: "students",
        name: "Students",
        section: DisplaySettingSection.Main,
        value: "3",
        defaultType: "3",
        twoName: {
            type: "studentNames",
            order: false,
            format: 0,
        },
        additional: [
            {
                type: "code",
                title: () => "Code",
                show: true,
                filter: false,
                example: "ALTHC01",
            },
            {
                type: "bosCode",
                title: () => "BOS Code",
                show: true,
                filter: false,
                example: "ALTHC01",
            },
            {
                type: "gender",
                title: () => "Gender",
                show: true,
                filter: true,
                formatter: (value: string) => {
                    switch (value) {
                        case "M":
                            return "Male";
                        case "F":
                            return "Female";
                        case "NB":
                            return "Non-binary";
                        default:
                            return "Not Specified";
                    }
                },
                example: "Female",
            },
            {
                type: "rollClass",
                title: () => "Roll Class",
                show: true,
                filter: true,
                details: () => "rollClass",
                example: "7A",
            },
            {
                type: "yearLevel",
                title: () => "Year Level",
                show: true,
                filter: true,
                descending: true,
                example: "7",
            },
            {
                type: "house",
                title: () => "House",
                show: true,
                filter: true,
                example: "Red",
            },
            {
                type: "homeGroup",
                title: () => "Home Group",
                show: true,
                filter: true,
                descending: false,
                example: "COE M",
            },
            {
                type: "webChoices",
                title: () => "webChoices",
                show: false,
                filter: false,
                example: "WC",
            },
            {
                type: "spareField1",
                title: () => "Spare Field 1",
                show: true,
                filter: true,
                example: "Spare 1",
            },
            {
                type: "spareField2",
                title: () => "Spare Field 2",
                show: true,
                filter: true,
                example: "Spare 2",
            },
            {
                type: "spareField3",
                title: () => "Spare Field 3",
                show: true,
                filter: true,
                example: "Spare 3",
            },
            {
                type: "studentListsEmail",
                title: () => "Email Address",
                show: true,
                filter: false,
                example: "althc01@school.edu.au",
            },
            {
                type: "class",
                title: () => "Class",
                details: () => "Classes",
                formatter: (value: Array<any>) => {
                    return value.map(item => item.Code);
                },
                show: false,
                filter: true,
                group: true,
                example: "7AHRMA",
            },
        ],
        example: function (builder) {
            return builder("ALTHC01", "Claire", "Mary", "Altherr");
        },
    },
    {
        type: "allReport",
        name: "All Reports",
        section: DisplaySettingSection.Reports,
        value: "",
        additional: [
            {
                type: "periodYardDutyLoads",
                title: () => "Period and Yard Duty Loads",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "absenceReasons",
                title: () => "Absence Reasons",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "cancellationReasons",
                title: () => "Cancellation Reasons",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "roomAvailabilityReasons",
                title: () => "Room Availability Reasons",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "replacementNotes",
                title: () => "Replacement Notes",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "roomReplacementNotes",
                title: () => "Room Changes Notes",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "teacherLoad",
                title: () => "Teacher Load",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "teacherCount",
                title: () => "Teacher Count",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "rollClasses",
                title: () => "Roll Classes",
                global: true,
                show: true,
                example: "",
            },
        ],
    },
    {
        type: "replacementReport",
        name: "Replacement Report",
        section: DisplaySettingSection.Reports,
        value: "",
        additional: [
            {
                type: "showReplacements",
                title: () => "Replacement teachers first column",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "listReplacementsAlphabetically",
                title: () => "Replacement teachers alphabetically",
                global: true,
                show: true,
                example: "",
            },
        ],
    },
    {
        type: "studentListReport",
        name: "Student List Report",
        section: DisplaySettingSection.Reports,
        value: "",
        additional: [
            {
                type: "studentListsName",
                title: () => "Show details in separate columns",
                global: true,
                show: true,
                example: "",
            },
        ],
    },
    {
        type: "timetableReport",
        name: "Timetable Report",
        section: DisplaySettingSection.Reports,
        value: "",
        additional: [
            {
                type: "timetableItemsOneRow",
                title: () => "Timetable items on one row",
                global: true,
                show: true,
                example: "",
            },
            {
                type: "transpose",
                title: () => "Transpose Information",
                global: true,
                show: true,
                example: "",
            },
        ],
    },
];
